<template>
  <header v-if='authenticated' class='ct-flex-row'>
    <div class='app-logo' v-on:click="doHome">&nbsp;</div>
    <div class='app-title item-flex-full'>
      <span class='app-name ft-font1'>Asalée</span>
      <span class='app-subtitle uppercase letter-spacing'>Gestion de l'assolement</span>
    </div>
    <div class='app-actions align-right'>
      <div id="btnLogout" v-on:click="doLogout"></div>
      <div v-if="isAdmin" id="btnParam" v-on:click="validateUsers"><span>{{ nbUsers }}</span></div>
      <div id="btnUser" v-on:click="openModalUser">
        <div class="identity">{{identity}}</div>
        <div class="version">Version {{ version }}</div>
      </div>
    </div>
    <Dialog
      :show='openModal'
      okText='Sauvegarder'
      :disabled="!pwdValid || password != passwordConfirm"
      cancelText='Annuler'
      title='Modifier mes informations'
      @cancel='openModal = false'
      @validate='updateUser'
    >
      <v-row>
        <v-field-text v-model="nomUser" label="Nom" name="nom" v-validate='"required"'/>
        <v-field-text v-model="prenomUser" label="Prénom" name="prenom" v-validate='"required"'/>
      </v-row>
      <v-row>
        <v-field-text v-model="emailUser" label="Email" name="email" v-validate='"required|email"' readonly/>
      </v-row>
      <div class='wrap'>
        <label for='password'>Mot de passe</label>
        <input v-model='password' type='password' name='password' id='password' required placeholder='Votre nouveau mot de passe' />
        <password-meter :password="password" />
        <span v-if="!pwdValid" class="form-error-pwd">Vous devez saisir au moins 8 caractères dont 1 majuscule, 1 chiffre et 1 caractère spécial.</span>
      </div>
      <div class='wrap'>
        <label for='passwordConfirm'>Confirmer le mot de passe</label>
        <input v-model='passwordConfirm' type='password' name='passwordConfirm' id='passwordConfirm' required placeholder='Confirmez votre nouveau mot de passe' />
        <span v-if="password != passwordConfirm" class="form-error-pwd">Les mots de passe ne correspondent pas</span>
      </div>
    </Dialog>
  </header>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Dialog from '@/components/Dialog.vue'
import passwordMeter from 'vue-simple-password-meter'

export default {
  name: 'TheHeader',
  components: { Dialog, passwordMeter },
  inject: ['$validator'],
  data () {
    return {
      openModal: false,
      nomUser: '',
      prenomUser: '',
      emailUser: '',
      password: '',
      passwordConfirm: '',
      pwdValid: true
    }
  },
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
      email: state => state.auth.user.email,
      nom: state => state.auth.user.nom,
      prenom: state => state.auth.user.prenom,
      nbUsers: state => state.auth.nbUsers,
      isAdmin: state => state.auth.user.role === 'admin'
    }),
    identity () {
      return [this.prenom, this.nom].join(' ').trim() || this.email
    },
    version () {
      return process.env.VUE_APP_VERSION
    }
  },

  methods: {
    ...mapActions(['logout', 'updateUserData']),
    doLogout () {
      this.logout()
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.$router.push({ name: 'login' })
        })
    },
    doHome () {
      this.$router.push({ name: 'exploitations' })
    },
    validateUsers () {
      this.$router.push({ name: 'validateusers' })
    },
    openModalUser () {
      this.openModal = true
      this.nomUser = this.nom
      this.prenomUser = this.prenom
      this.emailUser = this.email
      this.password = ''
      this.passwordConfirm = ''
      this.pwdValid = true
    },
    updateUser () {
      this.$validator.validateScopes().then((result) => {
        if (result) {
          this.updateUserData({ email: this.emailUser, nom: this.nomUser, prenom: this.prenomUser, password: this.password })
            .then(() => {
              this.$store.dispatch('success', { message: 'Informations modifiées avec succès.' })
              this.openModal = false
            })
        }
      })
    }
  },

  watch: {
    password: function () {
      let regexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/
      this.pwdValid = this.password === '' || regexp.test(this.password)
    }
  }
}
</script>
